"use strict";

exports.__esModule = true;
exports.ProfilePermissionsContext = void 0;
var _Utils = require("../../../Utils");
var _ProfilePermissionsController = require("./ProfilePermissionsController");
var ProfilePermissionsContext = exports.ProfilePermissionsContext = (0, _Utils.createEnhancedContext)({
  propName: "profilePermissions",
  defaultController: _ProfilePermissionsController.ProfilePermissionsController
});